module.exports = __webpack_public_path__ + "img/potential-left.381524b2.svg";